import { render, staticRenderFns } from "./recruitTit.vue?vue&type=template&id=5881b44d&scoped=true&"
import script from "./recruitTit.vue?vue&type=script&lang=js&"
export * from "./recruitTit.vue?vue&type=script&lang=js&"
import style0 from "./recruitTit.vue?vue&type=style&index=0&id=5881b44d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5881b44d",
  null
  
)

export default component.exports